import { useState } from 'react'
import { Loading, Button } from 'carbon-components-react'
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper'
import TileHeader from '../../components/TileHeader/TileHeader'
import ConfirmModal from '../../components/Modal/ConfirmModal'
import styled from 'styled-components'
// hooks
import useRegistriesGrid from './useRegistriesGrid'
import usePollReport from '../../hooks/usePollReport';
import { triggerReport } from '../../api/studyListApi';
import { toaster } from '../../helpers/toaster';

const Registries = () => {
  const {
    addRegistryButton,
    registrySearch,
    registriesGrid,
    registryLoading,
  } = useRegistriesGrid()

  const { startPolling, status: reportStatus } = usePollReport({
    onSuccess: () => { toaster('Registries report downloaded successfully', 'success'); },
    onError: () => toaster('Failed to generate report. Please try again.', 'error'),
  });

  const [openReportModal, setOpenReportModal] = useState(false);

  const handleGenerateReport = () => {
    setOpenReportModal(false);
    triggerReport('regids')
      .then(({ task_id }) => {
        toaster('Generating registries report...', 'info');
        startPolling(task_id);
      })
      .catch(() => toaster('Failed to start report generation.', 'error'));
  };

  return (
    <Container>
      <ContentContainer>
        <TileHeader
          title="Registries"
          size="lg"
        />
        {
          registryLoading ?
            <Loading/>
            :
            <></>
        }
        <RegistriesContent>
          <ActionBar>
            {registrySearch()}
            <ButtonPadding>
              <Button
                kind="secondary"
                onClick={() => setOpenReportModal(true)}
                disabled={reportStatus === 'polling'}
                style={btnStyle}
              >{reportStatus === 'polling' ? 'Generating...' : 'Generate Report'}</Button>
              {addRegistryButton()}
            </ButtonPadding>
          </ActionBar>
          {registriesGrid()}
        </RegistriesContent>
        <ConfirmModal
          title="Generate Report"
          content="Do you want to generate the report? This may take awhile. Navigating away from this page will stop the report generation."
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          onConfirm={handleGenerateReport}
        />
      </ContentContainer>
    </Container>
  )
}

export default Registries

const RegistriesContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px 24px;
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const ButtonPadding = styled.div`
  display: flex;
  gap: 8px;
`

const btnStyle = {
  padding: "11px 18px",
  height: "auto",
  minHeight: "unset",
  borderRadius: "10px",
  fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
  fontWeight: 700,
  fontSize: "13.5px",
};
